export default __webpack_public_path__ + "static/media/icon-152x152.0a2022ca.png";